import { FaHackerrank, FaStar } from "react-icons/fa"
import { SiCodechef, SiLeetcode } from "react-icons/si"
import TimeAgo from 'react-timeago'
import { Tooltip, Typography } from "@mui/material"
import MentorpickIcon from "../../Custom/Logo/MentorpickIcon"
import FillDetails from '../../../assets/filldetails.png'

const ProfileCard = ({userData, siteName, valid}) => {

    const stars = userData?.star_rating ?? 0
    const arr = []
    for(let i=0; i<stars; i++) arr.push('star')
    
    const logoMap = {

        "CODECHEF" : <SiCodechef/>,
        "CODEFORCES" : <SiCodechef/>,
        "LEETCODE" : <SiLeetcode/>,
        "HACKERRANK" : <FaHackerrank/>,
        "MENTORPICK" : <MentorpickIcon/>

    }

    const gradientMap = {
        "CODECHEF" : 'rgba(54, 29, 1, 0.8), rgba(222, 104, 20,0.8)',
        "CODEFORCES" : 'rgba(21, 140, 210, 0.9), rgba(168, 17, 17, 0.9)',
        "LEETCODE" : 'rgba(104, 57, 11, 0.8), rgba(243, 194, 22, 0.8)',
        "HACKERRANK" : 'rgba(0, 128, 0, 0.8), rgba(0, 0, 0, 0.8)',
        "MENTORPICK" : 'white, #f8fdfc, #008ce9'
    }
    
    let siteUrlMap = {
        "CODECHEF":"https://www.codechef.com/users/",
        "CODEFORCES":"https://codeforces.com/profile/",
        "LEETCODE":"https://leetcode.com/",
        "HACKERRANK":"https://www.hackerrank.com/",
        "MENTORPICK":"https://mentorpick.com/profile/"
      }
    
    return (
        <>
            <div className="card profile-card m-2 p-2 overflow-auto position-relative" style={{height: '28rem', width: '23rem', borderRadius: 15, border: 0}}>
                    <Tooltip title={<Typography>{userData?.site_user_handle || "invalid"}</Typography>} arrow placement="top">
                        <a href={`${siteUrlMap[siteName.toUpperCase()]}${userData?.site_user_handle}`} target="_blank" rel="noreferrer" className="text-primary w-100 text-center p-1 mb-2" style={{borderRadius: 10, fontWeight: 'bold'}}>
                            <h5 className={`text-center bg-secondary p-1 text-${siteName === "MENTORPICK" ? 'dark' : 'light'} border`} style={{borderRadius: 10, fontWeight: 'bold', background: `linear-gradient(to right, ${gradientMap[siteName]})`}}>{logoMap[siteName]}{" "}{siteName}</h5>
                        </a>
                    </Tooltip>

                {/* showing stars to the user */}
                {valid && userData ? <>
                    {
                        (siteName === 'CODECHEF' || siteName === 'HACKERRANK') && 
                        <div className="stars d-flex align-items-center justify-content-center mb-2">
                            {arr.map((star) => {
                                return <span><FaStar color="gold"/></span>
                            })}
                        </div>
                    }

                    {userData?.updatedAt && <p className="text-center text-secondary">Last Updated :  <TimeAgo date={new Date(userData?.updatedAt)}/></p>}

                    <div className="d-flex align-items-center flex-column m-2">
                        {
                            (userData?.solved_in_contest && userData?.solved_in_practice) ? <div className="d-flex w-100 justify-content-around mb-3">
                                <span className="badge bg-secondary text-center">Solved In Contest : {userData?.solved_in_contest}</span>
                                <span className="badge bg-secondary text-center"> Solved In Practice : {userData?.solved_in_practice}</span>
                            </div> : null
                        }
                        <p className="text-dark text-center bg-secondary w-100 p-1" style={{borderRadius: 10, fontWeight: 'bold'}}>Total Solved Count : {userData?.solved_count || 0}</p>
                        {
                            userData?.contests_participated > 0 && <p className="bg-secondary w-100 p-1 text-center" style={{borderRadius: 10, fontWeight: 550}}> <span style={{color: 'gray'}}>Contest Participated : </span>{userData?.contests_participated}<span style={{ color: 'red', marginLeft: 4 }}>*</span></p>
                        }
                        {
                            (userData?.most_recent_contest_name_participated || userData?.most_recent_contest_participated) ? <p className="bg-secondary w-100 p-1 text-center" style={{borderRadius: 10, fontWeight: 'bold'}}> <span style={{color: 'gray'}}>Last Contest : </span> {userData?.most_recent_contest_name_participated || userData?.most_recent_contest_participated}</p> : null
                        }
                        {userData?.rank > 0 && <p className="bg-secondary w-100 p-1 text-center" style={{borderRadius: 10, fontWeight: 'bold'}}> <span style={{color: 'gray'}}> Rank : </span>{userData?.rank}</p>}
                        {(userData?.rating || userData?.user_rating) ? <p className="bg-secondary w-100 p-1 text-center" style={{borderRadius: 10, fontWeight: 'bold'}}><span style={{color: 'gray'}}>Rating : </span>{userData?.user_rating || userData?.rating}</p> : null}
                        {userData?.highest_rating > 0 && <p className="bg-secondary w-100 p-1 text-center" style={{borderRadius: 10, fontWeight: 'bold'}}><span style={{color: 'gray'}}>Highest Rating : </span>{userData?.highest_rating}</p>}

                        {
                            siteName === 'HACKERRANK' && (
                                <>
                                    {userData?.score ? <p className="bg-secondary w-100 p-1 text-center" style={{borderRadius: 10, fontWeight: 'bold'}}> <span style={{color: 'gray'}}> Score: </span>{userData?.score}</p> : null}
                                    {userData?.hackerrank_data_structures_score && <p className="bg-secondary w-100 p-1 text-center" style={{borderRadius: 10, fontWeight: 'bold'}}> <span style={{color: 'gray'}}> Data Structure Score: </span>{userData?.hackerrank_data_structures_score}</p>}
                                    {userData?.hackerrank_algorithms_score && <p className="bg-secondary w-100 p-1 text-center" style={{borderRadius: 10, fontWeight: 'bold'}}> <span style={{color: 'gray'}}> Data Structure Score: </span>{userData?.hackerrank_algorithms_score}</p>}
                                </>
                            )
                        }
                    </div>

                </> : <div className="w-100 h-75 d-flex flex-column justify-content-center align-items-center">
                        <img src={FillDetails} alt="Fill Details" className="w-75 h-75"/>
                        <span>Oops .. Data not found / invalid for <span className="text-primary">{siteName}</span></span>
                    </div>
                }
            </div>
        </>
    )
}

export default ProfileCard